export default __webpack_public_path__ + "static/media/benefit_6.d1162a8e.png";